import Home from "./pages/Home";
import ProductSingle from "./pages/ProductSingle";


export  default [
    {path: '/', component: Home },
    {path: '/product-single', component: ProductSingle }
]
